import { __assign, __rest } from "tslib";
import * as React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { default as MuiChip } from '@material-ui/core/Chip';
import { Clear } from '../../internal/icons/small/Clear';
import { IconButton } from '../IconButton';
export var useStyles = makeStyles(function () {
    return createStyles({
        deleteButton: {
            minHeight: 'auto',
            minWidth: 'auto',
            height: '29px',
            margin: '-5px auto -5px 10px',
        },
    });
});
export var Chip = React.forwardRef(function (props, ref) {
    var clickable = props.clickable, deleteLabel = props.deleteLabel, deleteButtonProps = props.deleteButtonProps, label = props.label, onDelete = props.onDelete, onClick = props.onClick, other = __rest(props, ["clickable", "deleteLabel", "deleteButtonProps", "label", "onDelete", "onClick"]);
    var classes = useStyles(props);
    var isClickable = clickable || onClick;
    return (React.createElement(MuiChip
    // MUI sets role as button for clickable and deletable chips, we only want it set when clickable
    , __assign({ 
        // MUI sets role as button for clickable and deletable chips, we only want it set when clickable
        role: isClickable ? 'button' : undefined, tabIndex: isClickable ? 0 : -1, onDelete: onDelete, onClick: onClick, clickable: clickable, deleteIcon: React.createElement(React.Fragment, null), label: React.createElement(React.Fragment, null,
            label,
            onDelete && (React.createElement(IconButton, __assign({ className: classes.deleteButton, "aria-label": deleteLabel || 'delete', onClick: function (event) { return onDelete(event); } }, deleteButtonProps),
                React.createElement(Clear, null)))), ref: ref }, other)));
});
export default Chip;
//# sourceMappingURL=Chip.js.map